import axios from 'axios';
import { auth } from '../firebase/config';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Create authenticated axios instance
const createAuthClient = async () => {
  const token = await auth.currentUser?.getIdToken();
  return axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

export const contactGroupsAPI = {
  // Create a new group
  async create(groupData) {
    const client = await createAuthClient();
    const response = await client.post('/contact-groups/', groupData);
    return response.data;
  },

  // Get all groups
  async getAll() {
    const client = await createAuthClient();
    const response = await client.get('/contact-groups/');
    return response.data;
  },

  // Get a specific group
  async getById(groupId) {
    const client = await createAuthClient();
    const response = await client.get(`/contact-groups/${groupId}`);
    return response.data;
  },

  // Update a group
  async update(groupId, groupData) {
    const client = await createAuthClient();
    const response = await client.put(`/contact-groups/${groupId}`, groupData);
    return response.data;
  },

  // Delete a group
  async delete(groupId) {
    const client = await createAuthClient();
    const response = await client.delete(`/contact-groups/${groupId}`);
    return response.data;
  },

  // Assign contact to groups
  async assignContact(contactId, groupIds) {
    const client = await createAuthClient();
    const response = await client.post('/contact-groups/assign', {
      contact_id: contactId,
      group_ids: groupIds
    });
    return response.data;
  },

  // Get contacts in a group
  async getContactsByGroup(groupId) {
    const client = await createAuthClient();
    const response = await client.get(`/contact-groups/contacts/${groupId}`);
    return response.data;
  }
};
